import api from "./api";

export const postFetcher = async ([url, body = {}]) => {
  const response = await api.post(url, body);
  return response.data;
};

export const swrConfig = {
  fetcher: postFetcher,
  revalidateOnFocus: false,
  shouldRetryOnError: false,
};
